<template>
  <!-- 工业园平台操作后台 -->
  <!-- 侧边栏 -->
  <div class="aside">
    <!-- 使用介绍 -->
    <!-- MenuItem对应的name属性需要到配置对象MenuXml里配置
    name: {
      name: "用户管理", 面包屑名称
      subId: "2",      对应的系列编号
      path: "/ahome/auser", 对应的路由
      mname: "auser"   对应的名称name 建议name属性与路由名称一致 保留(存了，未被使用)
    }-->
    <Menu theme="light" width="100%" style="height:100%;font-size: 1.0625em" ref="side_menu"
      @on-select="selectMenu($event)" :active-name="activeName" :open-names="openList">
      <Submenu name="1">
        <template slot="title">
          <Icon type="ios-paper" />企业管理
        </template>
        <MenuItem name="config">企业配置</MenuItem>
      </Submenu>
      <Submenu name="2">

        <template slot="title">
          <Icon type="ios-people" />系统管理
        </template>
        <MenuItem name="auser">用户管理</MenuItem>
        <MenuItem name="arole">角色管理</MenuItem>
        <MenuItem name="apark">园区管理</MenuItem>
        <!-- <MenuItem name="apower">权限管理</MenuItem> -->
      </Submenu>
      <Submenu name="3">

        <template slot="title">
          <Icon type="ios-stats" />报表中心
        </template>
        <MenuItem name="current">检测数据</MenuItem>
        <MenuItem name="warnEvent">告警事件</MenuItem>
        <MenuItem name="warnSum">告警汇总</MenuItem>
        <MenuItem name="daily">环保日报</MenuItem>
        <MenuItem name="visitor">民众关注</MenuItem>
        <MenuItem name="availability">设备完好率</MenuItem>
        <MenuItem name="currentWarnSummary">当前异常汇总</MenuItem>
      </Submenu>
    </Menu>
  </div>
</template>

<style lang="scss" scope>
.aside {
  height: 100%;
  width: 13em;
}
</style>

<script>
/**
 * 代码设计备注：
 *   通过子菜单MenuItem的name属性在MenuXml的对象中寻找，
 *   找到对应的subId是主菜单name属性(subId用于设置展开主菜单)，
 *   对应的name是面包屑导航的名字,通过vuex管理
 */
import { mapState } from "vuex";

export default {
  data() {
    return {
      MenuXml: {
        auser: {
          name: "用户管理",
          subId: "2",
          path: "/ahome/auser",
          mname: "auser"
        },
        arole: {
          name: "角色管理",
          subId: "2",
          path: "/ahome/arole",
          mname: "arole"
        },
        apower: {
          name: "权限管理",
          subId: "2",
          path: "/ahome/apower",
          mname: "apower"
        },
        apark: {
          name: "园区管理",
          subId: "2",
          path: "/ahome/apark",
          mname: "apark"
        },
        config: {
          name: "企业配置",
          subId: "1",
          path: "/ahome/config",
          mname: "config"
        },
        current: {
          name: "检测数据",
          subId: "3",
          path: "/ahome/current",
          mname: "current"
        },
        warnEvent: {
          name: "告警事件",
          subId: "3",
          path: "/ahome/warnEvent",
          mname: "warnEvent"
        },
        warnSum: {
          name: "告警汇总",
          subId: "3",
          path: "/ahome/warnSum",
          mname: "warnSum"
        },
        daily: {
          name: "环保日报",
          subId: "3",
          path: "/ahome/daily",
          mname: "daily"
        },
        visitor: {
          name: "民众关注",
          subId: "3",
          path: "/ahome/visitor",
          mname: "visitor"
        },
        availability: {
          name: "设备完好率",
          subId: "3",
          path: "/ahome/availability",
          mname: "availability"
        },
        currentWarnSummary: {
          name: "当前异常汇总",
          subId: "3",
          path: "/ahome/currentWarnSummary",
          mname: "currentWarnSummary"
        },
      }
    };
  },
  computed: mapState({
    activeName: state => state.admin.menuing.name,
    openList(state) {
      this.$nextTick(() => {
        this.$refs.side_menu.updateOpened();
      });
      return state.admin.menuing.subList;
    }
  }),
  created() {
    let pathList = window.location.hash.split("/");
    let path = pathList[pathList.length - 1];
    if (this.MenuXml[path]) {
      this.$store.commit("editMenu", {
        name: path,
        subId: this.MenuXml[path].subId
      });
    }
  },
  methods: {
    selectMenu(msg) {
      let path = this.MenuXml[msg].path;
      let name = this.MenuXml[msg].name;
      if (path == window.location.pathname || !name) return;
      this.$store.commit("editBread", {
        path: path, // 全地址 /ahome/...
        name: name, // 中文名
        subId: this.MenuXml[msg].subId, // 父菜单name
        mname: this.MenuXml[msg].mname
      });
      this.$router.push(path);
    }
  }
};
</script>